export const ptPT = {
  // Common/Generic
  "common.name": "Nome",
  "common.establishmentName": "Nome do estabelecimento",
  "common.email": "E-mail",
  "common.password": "Palavra-passe",
  "common.country": "País",
  "common.state": "Distrito",
  "common.city": "Cidade",
  "common.all": "Todos",
  "common.active": "Ativo",
  "common.inactive": "Inativo",
  "common.createdAt": "Criado em",
  "common.yes": "Sim",
  "common.no": "Não",
  "common.add": "Adicionar",
  "common.edit": "Editar",
  "common.delete": "Excluir",
  "common.view": "Ver",
  "common.save": "Guardar",
  "common.saveNow": "Guardar agora",
  "common.cancel": "Cancelar",
  "common.confirm": "Confirmar",
  "common.undo": "Desfazer",
  "common.close": "Fechar",
  "common.create": "Criar",
  "common.update": "Atualizar",
  "common.search": "Pesquisar",
  "common.actions": "Ações",
  "common.status": "Situação",
  "common.success": "Sucesso",
  "common.error": "Erro",
  "common.loading": "A carregar",
  "common.back": "Voltar",
  "common.continue": "Continuar",
  "common.submit": "Enviar",
  "common.manage": "Gerir {name}",
  "common.export": "Exportar",
  "common.download": "Transferir",
  "common.title": "Título",
  "common.establishments": "Estabelecimentos",
  "common.establishmentsHelper":
    "Digite pelo menos 3 letras para procurar pelo estabelecimento",
  "establishmentAutocomplete.searchError":
    "Erro ao procurar estabelecimentos. Tente novamente.",
  "filters.title": "Filtros",
  "filters.onlyActive": "Somente ativas",
  "filters.sort.default": "Ordenar",
  "filters.sort.nameAsc": "Nome (A → Z)",
  "filters.sort.nameDesc": "Nome (Z → A)",
  "filters.sort.createdAsc": "Criado (Mais antigo)",
  "filters.sort.createdDesc": "Criado (Mais novo)",
  "cameras.confirmTitle": "Confirmar ação",
  "cameras.confirmMessage": "Tem certeza que deseja {name}?",
  "cameras.manageDescription": "logos, músicas, vídeos do site...",
  "cameras.openPreviewTooltip": "Abrir pré-visualização",

  // Common Messages
  "messages.saveSuccess": "Guardado com sucesso!",
  "messages.deleteSuccess": "Excluído com sucesso!",
  "messages.updateSuccess": "Atualizado com sucesso!",
  "messages.createSuccess": "Criado com sucesso!",
  "messages.loadError": "Erro ao carregar dados",
  "messages.saveError": "Erro ao guardar",
  "messages.deleteError": "Erro ao excluir",
  "messages.connectionError": "Houve um problema de ligação, tente novamente.",
  "messages.youtubeTokenExpired":
    "A ligação ao YouTube expirou. Renove a autorização da conta de YouTube no painel administrativo e tente novamente.",
  "global.generic_error": "Erro inesperado. Tente novamente.",
  "global.saved": "Guardado com sucesso.",
  "global.discarded": "Alterações descartadas.",
  "messages.serverError": "Erro interno do servidor, tente novamente.",
  "messages.unsavedChanges":
    "Tem alterações não guardadas. Deseja realmente sair sem guardar?",
  "messages.leaveWithoutSaving": "Sair sem guardar",
  "messages.stayOnPage": "Continuar a editar",
  "errorBoundary.title": "Algo correu mal",
  "errorBoundary.body": "Ocorreu um erro inesperado ao carregar esta página. Tente novamente.",
  "errorBoundary.retry": "Tentar novamente",
  "messages.confirmDelete":
    "Esta ação é irreversível. Deseja continuar mesmo assim?",
  "messages.fillRequiredFields": "Preencha todos os campos obrigatórios",
  "global.cancel": "Cancelar",
  "global.close": "Fechar",
  "global.save": "Guardar",

  // Common Validations
  "validation.required": "{field} é obrigatório",
  "validation.emailRequired": "E-mail é obrigatório",
  "validation.passwordRequired": "Palavra-passe é obrigatória",
  "validation.invalidEmail": "E-mail inválido",
  "validation.passwordMismatch": "Palavras-passe não coincidem",
  "validation.passwordCriteria":
    "A palavra-passe não atende aos critérios de segurança",

  // Common Placeholders
  "placeholder.enterEmail": "Introduza o seu e-mail",
  "placeholder.enterPassword": "Introduza a sua palavra-passe",
  "placeholder.search": "Pesquisar",
  "placeholder.searchByNameOrEmail": "Pesquisar por nome ou email",

  // Login
  "login.welcome": "Bem-vindo ao",
  "login.adminPanel": "Painel Administrativo",
  "login.subtitle": "Gerencie as suas câmeras, transmissões e assinaturas",
  "login.enterPanel": 'Entrar no "Painel Administrativo"',
  "login.enterEmailPlaceholder": "Introduza o seu e-mail",
  "login.enterPasswordPlaceholder": "Introduza a sua palavra-passe",
  "login.signIn": "Entrar",
  "login.success": "Sessão iniciada com sucesso!",
  "login.forgotPassword": "Esqueci-me da palavra-passe",
  "login.rememberMe": "Lembrar-me",
  "login.emailRequired": "E-mail é obrigatório",
  "login.passwordRequired": "Palavra-passe é obrigatória",
  "login.invalidCredentials": "E-mail ou palavra-passe incorretos",
  "login.tooManyAttempts": "Demasiadas tentativas de início de sessão. Aguarde alguns minutos e tente novamente.",
  "login.togglePasswordVisibility": "Mostrar/ocultar palavra-passe",

  // Forgot Password
  "forgotPassword.title": "Esqueceu-se da palavra-passe?",
  "forgotPassword.subtitle": "Vamos ajudá-lo a redefini-la rapidamente.",
  "forgotPassword.recover": "Recuperar palavra-passe",
  "forgotPassword.emailPlaceholder":
    "Insira o seu email para redefinir a palavra-passe",
  "forgotPassword.success": "E-mail de recuperação enviado com sucesso!",
  "forgotPassword.successTo": "Enviámos um link de recuperação para {email}.",
  "forgotPassword.sendToAnotherEmail": "Enviar para outro e-mail",
  "forgotPassword.spamHint": "Verifique também a sua caixa de spam ou lixeira.",
  "forgotPassword.error": "Erro interno do servidor, tente novamente.",

  // Reset Password
  "resetPassword.title": "Redefinir Palavra-passe",
  "resetPassword.subtitle": "Crie uma nova palavra-passe segura",
  "resetPassword.newPassword": "Nova Palavra-passe",
  "resetPassword.confirmPassword": "Confirmar Palavra-passe",
  "resetPassword.newPasswordPlaceholder": "Introduza a sua nova palavra-passe",
  "resetPassword.confirmPasswordPlaceholder":
    "Confirme a sua nova palavra-passe",
  "resetPassword.submit": "Redefinir Palavra-passe",
  "resetPassword.backToLogin": "Voltar ao Login",
  "resetPassword.requestNewLink": "Solicitar novo link",
  "resetPassword.success": "Palavra-passe redefinida com sucesso!",
  "resetPassword.error": "Erro interno do servidor, tente novamente.",
  "resetPassword.passwordRequired": "Palavra-passe é obrigatória",
  "resetPassword.confirmPasswordRequired":
    "Confirmação de palavra-passe é obrigatória",
  "resetPassword.criteriaTitle": "Critérios de segurança:",
  "resetPassword.min": "Mínimo {min} caracteres",
  "resetPassword.uppercase": "Pelo menos {min} letra maiúscula",
  "resetPassword.lowercase": "Pelo menos {min} letra minúscula",
  "resetPassword.digits": "Pelo menos {min} número",
  "resetPassword.symbols": "Pelo menos {min} símbolo (ex.: ! @ # $ % &)",
  "resetPassword.confirm": "Palavras-passe devem coincidir",
  "resetPassword.tokenValid": "Token válido",
  "resetPassword.checkingToken": "A verificar link...",
  "resetPassword.redirectingIn": "A redirecionar em {seconds}s...",

  // Not Found
  "notFound.oops": "Ups!",
  "notFound.pageNotFound": "Página não encontrada",
  "notFound.forbidden":
    "Não tem permissão para aceder a esta página. Contacte um administrador se acha que deveria ter acesso.",
  "notFound.backToHome": "Voltar ao início",

  // Drawer / Navigation
  "drawer.dashboard": "Dashboard",
  "drawer.cameras": "Câmaras",
  "drawer.liveStreams": "Transmissões ao Vivo",
  "drawer.subscriptions": "Assinaturas",
  "drawer.visitors": "Visitantes",
  "drawer.users": "Utilizadores",
  "drawer.links": "Ligações",
  "drawer.youtubeAccounts": "Contas do YouTube",
  "drawer.reports": "Relatórios",
  "drawer.audit": "Auditoria",
  "drawer.help": "Ajuda",
  "help.title": "Ajuda",
  "help.subtitle": "Passo a passo dos processos do dia a dia.",
  "help.notes": "Avisos",
  "drawer.more": "Mais",

  // Country
  "country.BR": "Brasil",
  "country.UY": "Uruguai",
  "country.PT": "Portugal",
  "country.US": "Estados Unidos",
  "country.ES": "Espanha",

  // AppBar
  "appBar.editUser": "Editar Utilizador",
  "appBar.changePassword": "Alterar Palavra-passe",
  "appBar.logout": "Sair",
  "appBar.build": "Versão",
  "appBar.build.unknown": "Desconhecida",

  // ChangePassword
  "changePassword.title": "Alterar Palavra-passe",
  "changePassword.currentPassword": "Palavra-passe Atual",
  "changePassword.currentPasswordPlaceholder": "Introduza a sua palavra-passe atual",
  "changePassword.success": "Palavra-passe alterada com sucesso!",
  "changePassword.error": "Erro ao alterar a palavra-passe, tente novamente.",
  "appBar.theme.light": "Claro",
  "appBar.theme.dark": "Escuro",
  "appBar.role.ADMIN": "Administrador",
  "appBar.role.OWNER": "Proprietário",
  "appBar.role.SUPPORT": "Suporte",

  // System User Form
  "systemUserForm.success": "Utilizador guardado com sucesso!",
  "systemUserForm.error": "Erro ao guardar utilizador.",
  "systemUserForm.searchError": "Erro ao procurar estabelecimentos",
  "systemUserForm.create": "Criar e Enviar Convite",
  "systemUserForm.role": "Função",
  "systemUserForm.roleHelper": "Define o nível de acesso do utilizador. ADMIN: acesso total. SUPORTE: acesso de leitura e gestão. PROPRIETÁRIO: acesso apenas aos próprios estabelecimentos.",
  "systemUserForm.inviteInfo": "Será enviado um e-mail ao utilizador com instruções para definir a sua palavra-passe e ativar a conta.",
  "systemUserForm.activeHelper": "Utilizadores inativos não conseguem aceder ao sistema.",
  "systemUserForm.establishmentsHiddenHint": "O campo de estabelecimentos foi ocultado, mas a seleção anterior foi mantida — volta a aparecer se escolher o papel Proprietário novamente.",

  // User Register Accept
  "userRegisterAccept.title": "Finalizar Registo",
  "userRegisterAccept.subtitle": "Defina a sua palavra-passe",
  "userRegisterAccept.description": "Foi convidado(a) a aceder ao sistema Meulance. Defina a sua palavra-passe para ativar a sua conta.",
  "userRegisterAccept.definePassword": "Defina a sua palavra-passe de acesso",
  "userRegisterAccept.newPassword": "Nova palavra-passe",
  "userRegisterAccept.confirmPassword": "Confirmar palavra-passe",
  "userRegisterAccept.newPasswordPlaceholder":
    "Introduza a sua nova palavra-passe",
  "userRegisterAccept.confirmPasswordPlaceholder":
    "Confirme a sua nova palavra-passe",
  "userRegisterAccept.submit": "Finalizar Registo",
  "userRegisterAccept.backToLogin": "Voltar ao Login",
  "userRegisterAccept.success":
    "Registo finalizado com sucesso! Pode fazer login agora.",
  "userRegisterAccept.error": "Erro ao finalizar registo",
  "userRegisterAccept.redirectHint": "Será redirecionado para o login dentro de instantes.",
  "userRegisterAccept.invalidToken": "Token inválido ou expirado",

  // Generic Form
  "genericForm.loadError": "Erro ao carregar dados",
  "genericForm.fillAllRequiredFields": "Preencha todos os campos obrigatórios",

  // Generic List
  "genericList.rowsPerPage": "Linhas por página",
  "genericList.displayedRows": "{from}-{to} de {count}",
  "genericList.moreThan": "mais que {to}",

  // System User
  "systemUser.title": "Utilizadores",
  "systemUser.role": "Perfil",
  "systemUser.add": "Adicionar utilizador",
  "systemUser.edit": "Editar utilizador",
  "systemUser.delete": "Excluir utilizador",
  "systemUser.createdAt": "Criado em",
  "systemUser.searchPlaceholder": "Pesquisar por nome ou email",
  "systemUser.sendPasswordReset":
    "Enviar email de redefinição de palavra-passe",
  "systemUser.passwordResetConfirmMessage": "Enviar e-mail de redefinição de palavra-passe para {email}?",
  "systemUser.fetchError": "Erro ao procurar utilizadores",
  "systemUser.deleteSuccess": "Utilizador excluído com sucesso",
  "systemUser.passwordResetSuccess":
    "Email de redefinição de palavra-passe enviado com sucesso para {email}",
  "systemUser.passwordResetError":
    "Erro ao enviar email de redefinição de palavra-passe",
  "systemUser.yes": "Sim",
  "systemUser.no": "Não",
  "systemUser.empty": "Nenhum utilizador encontrado.",
  "systemUser.selectHint": "Clique numa linha para selecionar",

  // Establishment Form
  "establishmentForm.title": "Estabelecimento",
  "establishmentForm.success": "Estabelecimento guardado com sucesso!",
  "establishmentForm.error": "Erro ao guardar estabelecimento.",
  "establishmentForm.create": "Registar",
  "establishmentForm.new": "Novo estabelecimento",
  "establishmentForm.timezone": "Fuso horário",
  "establishmentForm.channels": "Câmaras",
  "establishmentForm.channelsHint": "Cada câmara representa uma quadra deste estabelecimento.",
  "establishmentForm.channelsRestricted": "Apenas administradores/suporte podem gerir câmaras.",
  "establishmentForm.channelsSaveHint":
    "As alterações nas câmaras são guardadas de imediato ao clicar no ícone de guardar de cada linha — não fazem parte do guardar geral do formulário.",
  "establishmentForm.addChannel": "Adicionar câmara",
  "establishmentForm.channelName": "Nome da Câmara",
  "establishmentForm.actions": "Ações",
  "establishmentForm.confirmDeleteChannel":
    "Tem a certeza que deseja excluir esta câmara? A alteração será persistida apenas após guardar o formulário.",
  "establishmentForm.private": "Estabelecimento privado",
  "establishmentForm.manageVisitors": "Gerir Visitantes",

  // Logo Editor
  "logoEditor.title": "Editor de Logos",
  "logoEditor.deleteConfirmTitle": "Excluir Logo",
  "logoEditor.deleteConfirmMessage":
    "Esta ação é irreversível. Deseja continuar mesmo assim?",
  "logoEditor.deleteSuccess": "Logo excluído com sucesso!",
  "logoEditor.deleteError": "Erro ao excluir logo.",
  "logoEditor.saveSuccess": "Logos guardados com sucesso!",
  "logoEditor.saveError": "Erro ao guardar logos.",
  "logoEditor.loadLogosError": "Erro ao carregar logos.",
  "logoEditor.loadSnapshotError": "Erro ao carregar snapshot.",

  // Upload
  "upload.unsupportedFile": "Ficheiro não suportado",
  "upload.dropFiles": "Largue os ficheiros aqui",
  "upload.acceptedFormats": "Formatos aceitos: PNG, JPEG, GIF",

  // Logo List
  "logoList.addLogos": "Adicione os logos",

  // Delete Dialog
  "deleteDialog.confirmMessage":
    "Esta ação é irreversível. Deseja continuar mesmo assim?",

  // Cam Layout Editor
  "camLayoutEditor.preserveAspectRatio":
    "Manter proporção ao redimensionar os logos",
  "camLayoutEditor.undoPosition": "Anular última posição (Ctrl+Z)",

  // Establishment List
  "establishmentList.title": "Estabelecimentos",
  "establishmentList.channels": "Câmaras",
  "establishmentList.createdAt": "Data de Criação",
  "establishmentHashList.title": "Links",
  "establishmentHashList.createLink": "Criar novo link",
  "establishmentHashList.address": "Endereço",
  "establishmentHashList.empty": "Nenhum link registado",
  "establishmentHashList.fetchError": "Erro ao procurar os estabelecimentos",
  "establishmentHashList.deleteSuccess": "Link apagado com sucesso",
  "establishmentHashList.qrCode": "Ver código QR",
  "establishmentList.searchPlaceholder": "Pesquisar",
  "establishmentList.toggleStatus": "Ativar/Desativar",
  "establishmentList.toggleConfirmTitle": "Ativar/Desativar estabelecimento",
  "establishmentList.toggleConfirmMessage":
    "Tem a certeza que deseja {action} {name}?",
  "establishmentList.enable": "Ativar",
  "establishmentList.disable": "Desativar",
  "establishmentList.createLink": "Criar Ligação",
  "establishmentList.selectHint": "Selecione um estabelecimento para criar ligação",
  "establishmentList.fetchError": "Erro ao procurar os estabelecimentos",
  "establishmentList.statusUpdateSuccess": "Situação atualizada com sucesso",
  "establishmentList.deleteSuccess": "Estabelecimento apagado com sucesso",
  "establishmentList.empty": "Nenhum estabelecimento encontrado.",

  // Cameras
  "cameras.title": "Câmeras",
  "cameras.fetchError": "Erro ao buscar as câmeras",
  "cameras.noCameras": "Nenhuma câmera cadastrada",
  "cameras.noCamerasHintOperator": "Clique em \"Adicionar\" acima para registar o seu primeiro estabelecimento e câmaras.",
  "cameras.noCamerasHint": "Nenhum estabelecimento com câmaras foi encontrado para o seu utilizador.",
  "cameras.replaysLabel": "Câmara ativa",
  "cameras.playPreview": "Iniciar pré-visualização ao vivo",
  "cameras.pausePreview": "Pausar pré-visualização ao vivo",
  "cameras.streamUnavailable": "Sem transmissão ao vivo no momento",
  "cameras.streamReplaced": "A pré-visualização foi interrompida porque outra pessoa abriu uma câmara. Tente novamente.",
  "cameras.offlineNoPreview": "Câmara offline",
  "cameras.onlineFilterAria": "Filtrar por estado de ligação",
  "cameras.onlineFilterAll": "Todas",
  "cameras.onlineCount": "{online}/{total} online",
  "cameras.noCamerasForOnlineFilter": "Nenhuma câmara encontrada para esse filtro.",
  "cameras.offlineSince": "Offline desde {date}",
  "cameras.streamFallbackSnapshot":
    "A mostrar o snapshot mais recente quando disponível.",
  "cameras.openLegacyPreview": "Abrir câmara ao vivo",
  "cameras.legacyPreviewUnavailable":
    "Não foi possível obter o URL legado desta câmara.",
  "cameras.toggleTooltip": "Ativar/Desativar",
  "cameras.toggleTooltipAdmin": "Apenas ADMIN",
  "cameras.toggleSuccess": "Situação atualizada com sucesso",
  "cameras.searchPlaceholder": "Pesquisar por câmera ou estabelecimento",
  "cameras.channelCreatedAt": "Câmara criada em {date}",
  "cameras.toggleConfirmTitle": "Ativar/Desativar quadra",
  "cameras.toggleConfirmMessage": "Tem a certeza que deseja {action} {name}?",
  "cameras.enable": "Ativar",
  "cameras.disable": "Desativar",

  "cameras.channelUpdatedAt": "Câmara atualizada em {date}",
  "cameras.deleteSuccess": "Quadra apagada com sucesso",
  "cameras.deleteDialog.title": "Confirmar eliminação",
  "cameras.deleteDialog.titleEstablishment": "Eliminar estabelecimento",
  "cameras.deleteDialog.titleChannel": "Eliminar câmara",
  "cameras.deleteDialog.titleDevice": "Eliminar dispositivo",
  "cameras.deleteDialog.messageEstablishment": "Tem a certeza que deseja eliminar o estabelecimento \"{name}\"? Todos os canais e dispositivos serão removidos.",
  "cameras.deleteDialog.messageChannel": "Tem a certeza que deseja eliminar a câmara \"{name}\"?",
  "cameras.deleteDialog.messageDevice": "Tem a certeza que deseja eliminar o dispositivo \"{name}\"?",
  "cameras.deleteDialog.message":
    "Está prestes a eliminar {name}. Esta ação não pode ser desfeita.",
  "cameras.deleteDialog.warning":
    "Ao confirmar, a remoção será permanente e irreversível.",
  "cameras.deleteDialog.checkbox":
    "Confirmo que desejo eliminar e compreendo que esta ação é irreversível.",
  "cameras.deleteDialog.confirm": "Sim, eliminar",
  "deletionPreview.descriptionEstablishment":
    "Esta ação é permanente e vai eliminar tudo o que pertence ao estabelecimento \"{name}\":",
  "deletionPreview.descriptionChannel":
    "Esta ação é permanente e vai eliminar tudo o que pertence à câmara \"{name}\":",
  "deletionPreview.rowChannels": "Canais",
  "deletionPreview.rowVideos": "Vídeos",
  "deletionPreview.rowLogos": "Logótipos",
  "deletionPreview.rowFavorites": "Favoritos de visitantes",
  "deletionPreview.rowSavedVideos": "Vídeos guardados por visitantes",
  "deletionPreview.typeToConfirm": "Para confirmar, escreva \"{name}\" abaixo:",
  "deletionPreview.loadError":
    "Não foi possível carregar o que será eliminado. Tente novamente.",
  "deletionPreview.confirm": "Eliminar permanentemente",
  // Cameras - Details
  "establishment.paymentBlocked.title": "Acesso bloqueado por atraso no pagamento",
  "establishment.paymentBlocked.message": "A assinatura deste clube está com pagamento pendente. Contacte o financeiro para regularizar e libertar o acesso de novo.",
  "cameras.details.title": "Detalhes da Câmera",
  "cameras.details.tabDetails": "Detalhes",
  "cameras.details.subtitle": "Edite o nome da câmera e acesse configurações",
  "cameras.details.cameraLabel": "Câmara",
  "cameras.details.saveSuccess": "Nome atualizado com sucesso",
  "cameras.details.saveError": "Erro ao atualizar nome",
  "cameras.details.videos": "Vídeos do Site",
  "cameras.details.logos": "Logos e Músicas",
  "cameras.details.privateCourt": "Quadra Privada",
  "cameraLogos.title": "Logos e Músicas",
  "cameraLogos.divergenceWarning":
    "As câmaras desta quadra têm marcas de água diferentes. Escolha uma configuração para usar em todas.",
  "cameraLogos.fileTooLarge":
    "Um ou mais ficheiros excedem o limite de 5MB e não foram adicionados.",
  "cameraLogos.logos": "Logos",
  "cameraLogos.musicHint": "Escolha uma trilha e salve para esta câmara.",
  "cameraLogos.defaultLogoLabel": "Logótipo padrão Meu Lance",
  "cameraLogos.defaultLogoHint":
    "Controle se o logótipo padrão do Meu Lance aparece no canto superior esquerdo.",
  "cameraLogos.defaultLogoPreviewHint":
    "A pré-visualização mantém a proporção real da transmissão. Numa base de 1920 px, o logótipo padrão ocupa 276x67 px, a 60px da esquerda e 50px do topo.",
  "cameraLogos.defaultLogoSaved": "Logótipo padrão atualizado",
  "cameraLogos.defaultLogoSaveError": "Erro ao atualizar logótipo padrão",
  "cameraLogos.music": "Músicas",
  "cameraLogos.musicSaved": "Música guardada com sucesso",
  "cameraLogos.musicSaveError": "Erro ao guardar música",
  "cameraLogos.noMusic": "Sem música",
  "cameraLogos.positionTitle": "Posicionamento de logos",
  "cameraLogos.positionSubtitle": "Arraste e redimensione na imagem base",
  "cameraLogos.libraryTitle": "Biblioteca de logos",
  "cameraLogos.librarySubtitle": "Envie, remova e organize os seus logos",
  "logoEditor.loadingSnapshot": "A carregar snapshot...",
  "cameraPrivate.title": "Acesso Privado",
  "cameraPrivate.description":
    "Ative o acesso privado e defina uma palavra-passe para restringir o acesso a esta câmara.",
  "cameraPrivate.enable": "Ativar acesso privado",
  "cameraPrivate.password": "Palavra-passe",
  "cameraPrivate.passwordSetPlaceholder": "Palavra-passe definida — deixe em branco para manter",
  "cameraPrivate.passwordSetHelper": "Já existe uma palavra-passe configurada. Introduza uma nova apenas se quiser substituí-la.",
  "cameraPrivate.saveSuccess": "Configurações guardadas com sucesso",
  "cameraPrivate.authorizedTitle": "Utilizadores autorizados",
  "cameraPrivate.authorizedDescription":
    "Apenas os utilizadores listados aqui poderão assistir aos vídeos privados.",
  "cameraPrivate.manageAuthorized": "Gerir utilizadores autorizados",
  "cameraPrivate.passwordMode": "Privar com palavra-passe",
  "cameraPrivate.authorizedMode": "Privar com utilizadores autorizados",
  "cameraPrivate.mutuallyExclusive":
    "Só pode ativar um método de cada vez. Ao ligar um, o outro é desligado.",
  "cameraPrivate.passwordHint":
    "Defina a palavra-passe para permitir acesso quando este modo estiver ativo.",
  "cameraPrivate.save": "Guardar privacidade",
  "cameraPrivate.saveHint":
    "Guarda o modo atual (senha ou utilizadores autorizados).",
  // Create Link Dialog
  "createLinkDialog.title": "Criar ligação",
  "createLinkDialog.createButton": "Criar ligação",
  "createLinkDialog.success": "Ligação criada com sucesso",
  "createLinkDialog.error": "Erro ao criar ligação",
  "createLinkDialog.successTitle": "Ligação criada com sucesso",
  "createLinkDialog.linkLabel": "Ligação",
  "createLinkDialog.viewLinks": "Ver ligações",
  "createLinkDialog.qrCode": "Ver código QR",
  "qrCodeDialog.title": "Código QR",
  "qrCodeDialog.alt": "Código QR da ligação",
  "qrCodeDialog.error": "Não foi possível gerar o código QR",
  "qrCodeDialog.download": "Transferir PNG",
  "qrCodeDialog.downloadError": "Não foi possível transferir. Mantenha a imagem premida para a guardar.",
  // Confirmations
  "establishmentList.confirmDeleteTitle": "Apagar estabelecimento",
  "establishmentList.confirmDeleteMessage":
    "Tem a certeza que deseja apagar {name}? Esta ação apagará todas as quadras.",
  "cameras.confirmDeleteTitle": "Apagar quadra",
  "cameras.confirmDeleteMessage": "Tem a certeza que deseja apagar {name}?",
  "video.delete_success": "Vídeo eliminado com sucesso",
  "video.delete_error": "Não foi possível eliminar o vídeo. Verifique a sua ligação e tente novamente.",
  "video.restore_success": "Vídeo restaurado com sucesso",
  "video.restore_error": "Não foi possível restaurar o vídeo. Verifique a sua ligação e tente novamente.",
  "cameraVideos.title": "Vídeos do Site",
  "cameraVideos.filters.date": "Data",
  "cameraVideos.filters.hour": "Hora",
  "cameraVideos.filters.allDates": "Todas as datas",
  "cameraVideos.filters.allHours": "Todas as horas",
  "cameraVideos.filters.today": "Hoje",
  "cameraVideos.filters.status": "Estado",
  "cameraVideos.filters.active": "Ativos",
  "cameraVideos.filters.inactive": "Inativos",
  "cameraVideos.empty": "Nenhum vídeo encontrado para os filtros selecionados",
  "cameraVideos.emptyToday": "Ainda não há vídeos hoje.",
  "cameraVideos.confirmDeleteTitle": "Apagar vídeo",
  "cameraVideos.confirmDeleteMessage":
    "Tem a certeza que deseja apagar o vídeo de {name}?",
  "cameraVideos.deleteVideo": "Eliminar vídeo",
  "cameraVideos.thumbnailAlt": "Miniatura do vídeo",
  "cameraVideos.toggleStatus": "Ativar/Desativar vídeo",
  "cameraVideos.confirmToggleTitle": "Ativar/Desativar vídeo",
  "cameraVideos.confirmToggleMessage":
    "Tem a certeza que deseja {action} o vídeo de {name}?",
  "cameraVideos.enable": "ativar",
  "cameraVideos.disable": "desativar",
  "cameraVideos.tabProcessed": "Processados",
  "cameraVideos.tabPending": "Pendentes",
  "cameraVideos.pendingWarning":
    "Apenas vídeos enviados nas últimas 48 horas podem ser recuperados. Vídeos mais antigos já foram removidos automaticamente do armazenamento de origem.",
  "cameraVideos.pendingEmpty": "Nenhum vídeo pendente encontrado.",
  "cameraVideos.pendingLoadError": "Não foi possível carregar os vídeos pendentes.",
  "cameraVideos.pendingName": "Ficheiro",
  "cameraVideos.pendingLastModified": "Enviado em",
  "cameraVideos.reprocessSelected": "Reprocessar selecionados",
  "cameraVideos.reprocessSelectedCount": "Reprocessar {count} selecionado(s)",
  "cameraVideos.confirmReprocessTitle": "Reprocessar vídeos",
  "cameraVideos.confirmReprocessMessage":
    "Tem a certeza que deseja reprocessar {count} vídeo(s)?",
  "cameraVideos.reprocessSuccess": "Reprocessamento acionado com sucesso.",
  "cameraVideos.reprocessPartialError": "{count} vídeo(s) falharam ao reprocessar.",
  "cameraVideos.reprocessError": "Não foi possível reprocessar os vídeos selecionados.",
  "cameraVideos.pendingRefresh": "Atualizar lista",
  "cameraVideos.pendingStatus": "Estado",
  "cameraVideos.pendingStatusTriggered": "Reprocessamento acionado",
  "cameraVideos.pendingStatusError": "Falhou ao acionar",
  // Visitors List
  "visitorsList.title": "Visitantes",
  "visitorsList.selectedCount": "{count} selecionado(s)",
  "visitorsList.selectAll": "Selecionar todos",
  "visitorsList.deleteManyConfirm": "Tem a certeza que deseja excluir os {count} visitantes selecionados?",
  "visitorsList.phone": "Telefone",
  "visitorsList.establishment": "Estabelecimento",
  "visitorsList.createdAt": "Data de Registo",
  "visitorsList.searchPlaceholder": "Pesquisar",
  "visitorsList.searchMinChars": "Introduza pelo menos 3 caracteres",
  "visitorsList.exportAllHint": "Exporta a lista completa de visitantes (não respeita a seleção da tabela)",
  "visitorsList.deleteProgress": "A excluir {done} de {total}...",
  "visitorsList.deleteSuccess": "Utilizador apagado com sucesso",
  "visitorsList.enterEmail": "Introduza um email",
  "visitorsList.exportSuccess": "Solicitação realizada",
  "visitorsList.empty": "Nenhum visitante encontrado.",

  // Export Visitors Dialog
  "exportVisitorsDialog.confirmMessage": "Deseja exportar todos os contactos?",
  "exportVisitorsDialog.explanation": "Vai receber um ficheiro com a lista completa de visitantes por e-mail em alguns minutos.",
  "exportVisitorsDialog.emailPlaceholder": "Introduza o seu email",

  // Establishment Visitor
  "establishmentVisitor.title": "Visitantes Permitidos",
  "establishmentVisitor.createdAt": "Data de Criação",
  "establishmentVisitor.emailPlaceholder": "email1@exemplo.com",
  "establishmentVisitor.emailHelper":
    "Introduza o email para verificar a associação ou adicionar",
  "establishmentVisitor.notFoundAddHint":
    "Nenhum visitante encontrado com esse e-mail. Clique em Adicionar para o registar.",
  "establishmentVisitor.modeSearch": "A procurar visitante",
  "establishmentVisitor.modeAdd": "Nenhum resultado — adicionar novo visitante",
  "establishmentVisitor.selectedCount": "{count} selecionado(s)",
  "establishmentVisitor.deleteSelected": "Excluir selecionados",
  "establishmentVisitor.empty": "Nenhum visitante encontrado.",
  "establishmentVisitor.loadError": "Erro ao carregar visitantes permitidos",
  "establishmentVisitor.addSuccess": "E-mail adicionado com sucesso",
  "establishmentVisitor.addError": "Erro ao adicionar e-mails",
  "establishmentVisitor.addEmailNotFound": "O e-mail {email} ainda não tem registo de visitante — o acesso não foi concedido. Peça à pessoa para se registar e tente novamente.",
  "establishmentVisitor.deleteConfirm":
    "Confirma a exclusão dos seguintes e-mails?",
  "establishmentVisitor.deleteSuccess": "Visitantes removidos com sucesso",
  "establishmentVisitor.deleteError": "Erro ao excluir visitantes",

  // Dashboard
  "dashboard.noCameras": "Nenhuma câmara encontrada.",
  "dashboard.videoViews": "Visualização de Vídeos",
  "dashboard.videoDownloads": "Transferir Vídeos",
  "dashboard.videos": "Vídeos Gerados",
  "dashboard.adminTitle": "Painel de Controlo",
  "dashboard.ownerProfileTitle": "Perfil do Proprietário",
  "dashboard.sectionOperational": "Estado das Câmaras",
  "dashboard.sectionMetrics": "Métricas de Audiência",
  "dashboard.sectionLives": "Transmissões",
  "dashboard.sectionAlerts": "Alertas",
  "dashboard.noLivesToShow": "Nenhuma transmissão para mostrar.",
  "dashboard.noAlerts": "Nenhum alerta de momento.",
  "dashboard.alertCamerasOffline": "{count} câmara(s) offline. Toque para verificar.",
  "dashboard.alertYoutubeReconnect": "A sua ligação ao YouTube precisa de ser renovada. Toque para reconectar.",
  "dashboard.alertPaymentPending": "{count} transmissão(ões) com pagamento pendente. Toque para ver.",
  "dashboard.quickActionCreateLive": "Nova transmissão",
  "dashboard.quickActionManageCameras": "Gerir câmaras",
  "dashboard.quickActionConfigureLogos": "Configurar logótipos",
  "dashboard.quickActionConnectYoutube": "Ligar ao YouTube",
  "dashboard.quickActionScoreboard": "Aceder ao placar",
  "dashboard.filtersLabel": "Filtros",
  "dashboard.stateFilterLabel": "Estado",
  "dashboard.cityFilterLabel": "Cidade",
  "dashboard.projectedImpressions": "Impressões Projetadas",
  "dashboard.cameraStatusTitle": "Estado das Câmaras",
  "dashboard.cameraOnline": "Online",
  "dashboard.cameraOffline": "Offline",
  "dashboard.cameraName": "Nome",
  "dashboard.cameraStatusColumn": "Estado Câmara",
  "dashboard.cameraLastEvent": "Último Evento",
  "dashboard.cameraLastCommunication": "Última Comunicação",
  "dashboard.cameraLastCheck": "Última Verificação",
  "dashboard.cameraSdStatus": "Estado Cartão SD",
  "dashboard.cameraButtonStatus": "Estado Botoneira",
  "dashboard.buttonOk": "OK",
  "dashboard.buttonNoShort": "Sem curto",
  "dashboard.buttonOffline": "Offline",
  "dashboard.buttonNotConfigured": "Não configurado",
  "dashboard.buttonHealthBadTitle": "Botoneira com problema",
  "dashboard.buttonHealthOkHint": "Botoneira a funcionar normalmente, sem curto-circuito detetado.",
  "dashboard.buttonHealthReasonVeryLong": "Vídeo acima de 5 minutos",
  "dashboard.buttonHealthReasonThreeLong":
    "3 vídeos consecutivos acima de 2 minutos",
  "dashboard.buttonShortCircuit": "Em curto",
  "dashboard.establishmentLabel": "Estabelecimento",
  "dashboard.establishmentLabelCameras": "Estabelecimento (câmaras)",
  "dashboard.establishmentLabelMetrics": "Estabelecimento (métricas)",
  "dashboard.formatHelper": "Aplica-se a todos os gráficos abaixo",
  "dashboard.sdFormat": "Formatar cartão SD",
  "dashboard.sdResetHint": "Resetar cartão",
  "dashboard.sdFormatConfirm":
    "Deseja formatar o cartão SD desta câmara? Essa ação pode levar alguns minutos.",
  "dashboard.sdFormatSuccess": "Formatação solicitada.",
  "dashboard.sdFormatError": "Erro ao solicitar formatação do cartão SD.",
  "datePicker.month": "Mês",
  "datePicker.year": "Ano",
  "datePicker.clear": "Limpar",
  "datePicker.today": "Hoje",
  "timePicker.hour": "Hora",
  "timePicker.minute": "Minuto",
  "timePicker.now": "Agora",
  "timePicker.period": "Período",
  "timePicker.am": "AM",
  "timePicker.pm": "PM",
  "dashboard.sdOk": "OK",
  "dashboard.sdError": "Erro",
  "dashboard.statusUnknown": "N/D",
  "dashboard.daysWithoutEvent": "+{days} dias sem evento",
  "dashboard.loadError": "Erro ao carregar dados do painel",
  "dashboard.cameraStatusPartialError": "Erro ao carregar estado de {count} estabelecimento(s).",
  "dashboard.cameraStatusError": "Erro ao carregar estado das câmaras.",
  "dashboard.metricsRestricted": "As métricas de audiência estão disponíveis para administradores, suporte e proprietários.",

  // Live Streams
  "liveStreams.title": "Transmissões ao Vivo",
  "liveStreams.subtitle": "{place}",
  "liveStreams.subtitleEmpty": "Selecione um estabelecimento",
  "liveStreams.tabs.schedule": "Agendamento",
  "liveStreams.newLive": "Nova transmissão",
  "liveStreams.stepWhereWhen": "Onde e quando",
  "liveStreams.stepWhere": "Onde",
  "liveStreams.stepConfiguration": "Configuração",
  "liveStreams.stepAudioReview": "Áudio e revisão",
  "liveStreams.reviewTitle": "Resumo da transmissão",
  "liveStreams.reviewSchedule": "Data/Hora:",
  "liveStreams.tabs.lives": "Histórico de Transmissão",
  "liveStreams.tabs.playlists": "Playlists",
  "liveStreams.tabs.media": "Mídias",
  "youtubeConnection.title": "Ligação YouTube",
  "youtubeConnection.subtitle": "Ligação da sua conta ao YouTube.",
  "youtubeConnection.prerequisitesAria": "Subscritores no YouTube para transmissão em direto",
  "youtubeConnection.prerequisitesInfo":
    "O YouTube costuma exigir no mínimo 50 subscritores no canal para libertar transmissão em direto. Confirme na Central de Ajuda do YouTube caso as regras mudem.",
  "youtubeConnection.connected": "Ligado",
  "youtubeConnection.disconnected": "Desligado",
  "youtubeConnection.requiresReconnect": "Reconexão necessária",
  "youtubeConnection.renewalError": "Falha temporária na renovação",
  "youtubeConnection.lastSyncedAt": "Última sincronização: {date}",
  "youtubeConnection.reconnectPromptTitle": "A sua ligação ao YouTube precisa de ser renovada",
  "youtubeConnection.reconnectPromptMessage":
    "A ligação da sua conta do YouTube expirou. Enquanto não for renovada, novas transmissões podem falhar ou ficar indisponíveis. Pretende reconectar agora?",
  "youtubeConnection.reconnectPromptCta": "Reconectar agora",
  "youtubeConnection.reconnectPromptLater": "Lembrar mais tarde",
  "youtubeConnection.connect": "Ligar conta",
  "youtubeConnection.renewOAuth": "Renovar vínculo",
  "youtubeConnection.refreshConnection": "Atualizar ligação",
  "youtubeConnection.reconnect": "Religar conta",
  "youtubeConnection.disconnect": "Desligar",
  "youtubeConnection.support": "Falar com suporte",
  "youtubeConnection.supportWhatsappMessage":
    "Olá! Preciso de ajuda com a ligação YouTube no Meu Lance.",
  "youtubeConnection.blockingWarning":
    "Liga a tua conta do YouTube para agendar transmissões em direto.",
  "youtubeConnection.disconnectNotice": "Conta de YouTube desvinculada.",
  "youtubeConnection.disconnectConfirmTitle": "Desligar a conta do YouTube?",
  "youtubeConnection.disconnectConfirmBody":
    "Terá de voltar a ligar a conta para agendar e gerir transmissões na aplicação.",
  "youtubeAdminAccounts.title": "Contas do YouTube",
  "youtubeAdminAccounts.column.channel": "Canal",
  "youtubeAdminAccounts.column.scheduleLimit": "Limite de agendamentos",
  "youtubeAdminAccounts.column.lastSyncedAt": "Última sincronização",
  "youtubeAdminAccounts.status.connected": "Ligada",
  "youtubeAdminAccounts.status.disconnected": "Desligada",
  "youtubeAdminAccounts.status.requiresReconnect": "Reconexão necessária",
  "youtubeAdminAccounts.status.renewalError": "Falha temporária na renovação",
  "youtubeAdminAccounts.connect": "Ligar",
  "youtubeAdminAccounts.unlink": "Desligar",
  "youtubeAdminAccounts.ownerManagedChip": "Proprietário",
  "youtubeAdminAccounts.empty": "Nenhuma conta registada.",
  "youtubeAdminAccounts.createTitle": "Nova conta do YouTube",
  "youtubeAdminAccounts.editTitle": "Editar conta do YouTube",
  "youtubeAdminAccounts.form.name": "Nome",
  "youtubeAdminAccounts.form.scheduleLimit": "Limite de agendamentos",
  "youtubeAdminAccounts.form.active": "Ativa",
  "youtubeAdminAccounts.createSuccess": "Conta criada. Clique em \"Ligar\" para vincular à Google.",
  "youtubeAdminAccounts.updateSuccess": "Conta atualizada.",
  "youtubeAdminAccounts.unlinkSuccess": "Conta desligada da Google.",
  "youtubeAdminAccounts.deleteSuccess": "Conta removida.",
  "youtubeAdminAccounts.unlinkConfirmTitle": "Desligar esta conta da Google?",
  "youtubeAdminAccounts.unlinkConfirmMessage":
    "A conta \"{name}\" deixará de transmitir até que alguém a ligue novamente.",
  "youtubeAdminAccounts.deleteConfirmTitle": "Eliminar esta conta?",
  "youtubeAdminAccounts.deleteConfirmMessage":
    "A conta \"{name}\" será removida permanentemente. Esta ação não pode ser desfeita.",
  "youtubeAdminAccounts.deactivateConfirmTitle": "Desativar esta conta?",
  "youtubeAdminAccounts.deactivateConfirmMessage":
    "A conta \"{name}\" deixa de poder ser usada em novas transmissões (agendamentos ativos agora: {count}).",
  "liveDetails.noYoutubePoolAccountAvailable":
    "Nenhuma conta do YouTube do pool está ativa e ligada neste momento. Ligue ou reative uma conta antes de agendar.",
  "liveStreams.ownerScheduledNoticeTitle": "Transmissão agendada com sucesso",
  "liveStreams.ownerScheduledNoticeBody":
    "Agora só precisa de aguardar o início da transmissão. Pode conferir os dados nesta tela e ainda editar o que for necessário.",
  "liveStreams.filterDescription": "Filtro por descrição",
  "liveStreams.filterDevice": "Filtro por dispositivo",
  "liveStreams.filterEstablishment": "Filtro por estabelecimento",
  "liveStreams.filterHistoryStatus": "Filtro por status",
  "liveStreams.historyStatusWaiting": "Aguardando",
  "liveStreams.historyStatusCompleted": "Completados",
  "liveStreams.filterAll": "Todos",
  "liveStreams.youtubeAccount": "Conta YouTube",
  "liveStreams.youtubeAccountPlaceholder": "Selecione a conta YouTube",
  "liveStreams.youtubeAccountOwn": "A minha conta (ligada)",
  "liveStreams.scheduleAdminOnly":
    "Data e hora já não podem ser alteradas: a transmissão foi finalizada.",
  "liveStreams.ownerConfirmNotice":
    "Ao confirmar, autoriza a cobrança para realizar esta transmissão. A data e a hora não poderão ser alteradas depois.",
  "liveStreams.ownerScheduleConfirmBody":
    "Deseja confirmar o agendamento para {place} - {court} no dia {date}, às {time}, com duração de {duration}?",
  "liveStreams.ownerScheduleSummary":
    "Agendamento: {place} - {court} no dia {date}, às {time}, com duração de {duration}.",
  "liveStreams.ownerScheduleFieldPlaceCourt": "Estabelecimento/Quadra:",
  "liveStreams.ownerScheduleFieldTime": "Hora:",
  "liveStreams.ownerScheduleFieldDuration": "Duração:",
  "liveStreams.upcomingTitle": "Próximas alterações de status de LIVES",
  "liveStreams.name": "Título da Transmissão",
  "liveStreams.playlist": "Playlist",
  "liveStreams.period.title": "Nova transmissão por período",
  "liveStreams.period.startDate": "Data de início",
  "liveStreams.period.endDate": "Data de fim",
  "liveStreams.period.dailyStartTime": "Hora de início",
  "liveStreams.period.dailyEndTime": "Hora de fim",
  "liveStreams.period.dailyTimeInvalid": "A hora de fim deve ser posterior à hora de início.",
  "liveStreams.period.preview": "Ver resumo",
  "liveStreams.period.confirm": "Criar transmissão",
  "liveStreams.period.previewLoading": "A calcular o resumo...",
  "liveStreams.period.daysCount": "{count, plural, one {# dia de transmissão} other {# dias de transmissão}}",
  "liveStreams.period.willSplitWarning":
    "{count, plural, one {# dia ultrapassa 9 horas} other {# dias ultrapassam 9 horas}} e será dividido automaticamente em Parte 1 e Parte 2.",
  "liveStreams.period.retry": "Tentar novamente",
  "liveStreams.period.giveUp": "Desistir",
  "liveStreams.period.viewDetails": "Ver detalhes",
  "liveStreams.period.status.SCHEDULED": "Agendado",
  "liveStreams.period.status.CREATED": "Criado",
  "liveStreams.period.status.FAILED": "Falhou",
  "liveStreams.period.status.SKIPPED": "Ignorado",
  "liveStreams.period.status.ABANDONED": "Desistido",
  "liveStreams.period.ownerMaxDaysExceeded":
    "Pode agendar no máximo {days} dias por período.",
  "liveStreams.period.billingAwaiting":
    "A aguardar confirmação de todos os agendamentos para libertar o pagamento.",
  "liveStreams.period.billingConfirmed":
    "Todos os agendamentos foram confirmados — pagamento libertado.",
  "liveStreams.period.billingConfig.title": "Configurar taxa diária",
  "liveStreams.period.billingConfig.dailyRate": "Taxa diária (R$)",
  "liveStreams.period.billingConfig.invalidRate": "Indique um valor superior a zero.",
  "liveStreams.status": "Status",
  "liveStreams.nextChange": "Próxima alteração",
  "liveStreams.noUpcoming": "Nenhuma alteração prevista",
  "liveStreams.livesTitle": "Histórico",
  "liveStreams.tabUpcoming": "Próximas",
  "liveStreams.tabPast": "Anteriores",
  "liveStreams.noLives": "Nenhuma live encontrada",
  "liveStreams.startsAt": "Início:",
  "liveStreams.endsAt": "Fim:",
  "liveStreams.paymentStatusLabel": "Status pagamento:",
  "liveStreams.paymentColumn": "Pagamento",
  "liveStreams.paymentStatusPaid": "Pago",
  "liveStreams.paymentStatusPending": "Pendente",
  "liveStreams.paymentStatusDirectFinance": "Direto com financeiro",
  "liveStreams.paymentStatusAwaitingSchedules": "A aguardar agendamentos",
  "liveStreams.paymentStatusUnknown": "Não informado",
  "liveStreams.refreshPaymentStatus": "Atualizar pagamento",
  "liveStreams.paymentStatusUpdatedPaid": "Status de pagamento atualizado: pago.",
  "liveStreams.paymentStatusUpdatedPending":
    "Status de pagamento atualizado: ainda pendente.",
  "liveStreams.paymentStatusUpdatedDirectFinance":
    "Status de pagamento atualizado: direto com financeiro.",
  "liveStreams.selectLive": "Selecione uma live para editar",
  "liveStreams.pendingTitle": "Transmissões Pendentes",
  "liveStreams.openLinkAdmin": "Abrir Link/Adm",
  "liveStreams.openAdmin": "Abrir Admin",
  "liveStreams.openDetails": "Detalhes",
  "liveStreams.configureTitle": "Configurações",
  "liveStreams.configureSubtitle": "Personalize logos, músicas e placar",
  "liveStreams.logosTitle": "Logos",
  "liveStreams.logosDesc": "Carregue e posicione logos na transmissão",
  "liveStreams.uploadLogos": "Carregar logos",
  "liveStreams.bannerTitle": "Banners",
  "liveStreams.bannerDesc": "Gerir banners da transmissão",
  "liveStreams.manageBanners": "Gerir banners",
  "liveStreams.startAt": "Início",
  "liveStreams.startTime": "Hora início",
  "liveStreams.endAt": "Fim",
  "liveStreams.endTime": "Hora fim",
  "liveStreams.estimatedPrice": "Valor estimado: {price}",
  "liveStreams.priceFormulaHint": "R$3 na 1ª hora + R$2 por hora adicional, até R$15.",
  "liveStreams.endTimeHour": "Hora",
  "liveStreams.endTimeMinute": "Minutos",
  "liveStreams.maxTwoHoursHint": "Duração fixa: 2 horas",
  "liveStreams.maxNineHoursHint":
    "A transmissão não pode ultrapassar 9 horas a partir da data de início.",
  "liveStreams.scoreType": "Tipo de placar",
  "liveStreams.selectPlaceholder": "Selecione...",
  "liveStreams.scoreSimple": "Simples",
  "liveStreams.scorePadel": "Pádel",
  "liveStreams.scoreVolley": "Vôlei",
  "liveStreams.scoreCustom": "Personalizado",
  "liveStreams.musicTitle": "Música",
  "liveStreams.musicWithBackground": "Com música de fundo",
  "liveStreams.musicWithoutBackground": "Sem música",
  "liveStreams.musicPlaybackHint":
    "As músicas serão reproduzidas em sequência e repetidas até ao fim da transmissão.",
  "liveStreams.musicPreviewList": "Pré-visualização das músicas",
  "liveStreams.musicPreviewUnavailable":
    "Nenhuma música disponível para pré-visualização neste momento.",
  "liveStreams.playlist1": "Playlist 1",
  "liveStreams.playlist2": "Playlist 2",
  "liveStreams.playlist3": "Playlist 3",
  "liveStreams.playlist4": "Playlist 4",
  "liveStreams.playlist5": "Playlist 5",
  "liveStreams.adminLink": "Link do administrador",
  "liveStreams.adminLinkPlaceholder":
    "Copie o link para aceder ao painel do administrador",
  "liveStreams.advanced": "Avançado",
  "liveStreams.templateHelp": "Selecione um template (se disponível)",
  "liveStreams.template": "Template",
  "liveStreams.createAndPay": "Guardar",
  "liveStreams.directFinancePayment": "Pagamento direto no financeiro",
  "liveStreams.noTemplates": "Não há templates disponíveis para esta seleção.",
  "liveStreams.noCourts": "Não há quadras disponíveis para esta seleção.",
  "liveStreams.noEstablishmentsFound": "Nenhum estabelecimento encontrado.",
  "liveStreams.draftRestoredHint": "A continuar um agendamento que tinha começado antes.",
  "liveStreams.establishmentsLoadError": "Erro ao carregar estabelecimentos. Tente novamente.",
  "liveStreams.disabledCreating": "A criar transmissão...",
  "liveStreams.disabledYoutubeNotConnected": "Liga a tua conta do YouTube primeiro",
  "liveStreams.disabledLoading": "A carregar...",
  "liveStreams.disabledPastStart": "Data/hora de início no passado",
  "liveStreams.disabledTooFar": "Data de início muito distante (máx 48h)",
  "liveStreams.disabledInvalidEnd": "Horário de fim inválido (máx 9h)",
  "liveStreams.disabledSelectEstablishment": "Selecione um estabelecimento",
  "liveStreams.disabledSelectCamera": "Selecione uma câmara/quadra",
  "liveStreams.disabledSelectPlaylist": "Selecione uma playlist",
  "liveStreams.playlistRequired": "Selecione uma playlist.",
  "liveStreams.playlistAdminOnly":
    "A playlist só pode ser alterada por um administrador.",
  "liveStreams.playlistLockedAfterBind":
    "A playlist não pode ser alterada após vinculada a esta transmissão.",
  "liveStreams.playlistMissingMapping":
    "Este estabelecimento não tem playlist associada. Um administrador precisa associar em Playlists.",
  "liveStreams.noPlaylistForEstablishment":
    "Nenhuma playlist associada para este estabelecimento.",
  "liveStreams.pastStart": "Não é possível agendar no passado.",
  "liveStreams.startTooFar":
    "Só pode agendar com até 48 horas de antecedência.",
  "liveStreams.start48hHint": "Só pode agendar nas próximas 48 horas.",
  "liveStreams.invalidRange": "Intervalo inválido.",
  "liveDetails.onlyWaitingOrRunningSchedulesEditable":
    "Apenas transmissões em espera ou em curso podem ser editadas.",
  "liveDetails.scheduleNotIdentified": "Não foi possível identificar o agendamento para edição.",
  "liveStreams.scheduleConflictPeriod":
    "O estabelecimento e a quadra escolhidos já têm um agendamento dentro do período selecionado.",
  "liveStreams.mockCreated":
    "Agendamento simulado localmente para testes (backend indisponível).",
  "liveStreams.minDuration": "Duração mínima: {minutes} min.",
  "liveStreams.maxDuration": "Duração máxima: {minutes} min.",

  // Live Status
  "liveStatus.waitStart": "A aguardar",
  "liveStatus.started": "Iniciado",
  "liveStatus.finished": "Finalizado",
  "liveStatus.failed": "Falhou",
  "liveStatus.canceled": "Cancelado",

  // Live Payment
  "livePayment.title": "Pagamento",
  "livePayment.subtitle": "Conclua o pagamento para finalizar a transmissão",
  "livePayment.pending": "Pendente",
  "livePayment.billedValueLabel": "Valor cobrado",
  "livePayment.paidAtLabel": "Data do pagamento",
  "livePayment.paymentMethodLabel": "Forma de pagamento",
  "livePayment.back": "Voltar",
  "livePayment.pay": "Pagar agora",
  "livePayment.continue": "Continuar",
  "livePayment.autoContinueToast": "Pagamento confirmado! A concluir o agendamento...",
  "livePayment.autoContinueCountdown": "A redirecionar em {seconds}s...",
  "livePayment.cancelAutoContinue": "Cancelar redirecionamento automático",
  "livePayment.paymentPendingHint":
    "Pagamento pendente. Pode abrir o Mercado Pago para concluir.",
  "livePayment.checkingPayment": "A verificar pagamento...",
  "livePayment.noPaymentYet": "Pagamento ainda não realizado.",
  "livePayment.paymentConfirmed": "Pagamento confirmado.",
  "livePayment.noPaymentRequired":
    "Nenhum pagamento necessário. Pode continuar.",
  "livePayment.hint":
    "Após o pagamento, será redirecionado para configurar a transmissão.",
  "livePayment.fallbackName": "Transmissão",
  "livePayment.fallbackPlace": "Estabelecimento",
  "livePayment.fallbackDevice": "Câmara",
  "livePayment.openInNewTabHint":
    "Se o botão de pagamento não aparecer, use a ligação abaixo para abrir o checkout numa nova aba.",
  "livePayment.openInNewTab": "Abrir checkout numa nova aba",
  "livePayment.verifyPayment": "Já paguei",
  "livePayment.statusRefunded":
    "O pagamento anterior foi estornado. Efetue um novo pagamento.",
  "livePayment.statusRejected":
    "O pagamento foi recusado. Tente novamente ou use outra forma de pagamento.",
  "livePayment.statusCancelled":
    "O pagamento foi cancelado. Efetue um novo pagamento.",
  "livePayment.statusInProcess":
    "Pagamento em processamento. Aguarde a confirmação.",
  "livePayment.statusInMediation":
    "Pagamento em análise. Contacte o Mercado Pago se precisar de ajuda.",
  "livePayment.statusChargedBack":
    "Houve um estorno. Efetue um novo pagamento.",

  // Live Link
  "liveLink.title": "Transmissão",
  "liveLink.subtitle": "Link do administrador para configurar a transmissão",
  "liveLink.adminLinkTitle": "Link do administrador",
  "liveLink.adminLinkPlaceholder":
    "O link será apresentado após a criação da transmissão",
  "liveLink.adminLinkHint":
    "Use este link para aceder ao painel e configurar logos, música e placar.",
  "liveLink.openNarratorPanel": "Abrir painel do administrador",

  "liveBranding.schedulingTitle": "A configurar transmissão",
  "liveBranding.schedulingBody":
    "Estamos a preparar vídeo, logos e ligação da câmara. Isto pode demorar alguns segundos.",
  "liveBranding.ownerPaymentTitle": "Confirmação",
  "liveBranding.ownerPaymentConfirm": "Confirmar",
  "liveBranding.ownerPaymentConfirmed":
    "Pedido enviado. A nossa administração entrará em contacto para a cobrança.",

  // Live Admin
  "liveAdmin.title": "Admin da Transmissão",
  "liveAdmin.subtitle": "Gira placar, banners, logos e música",
  "liveAdmin.subtitleWithLive": "{name} · {device} · {start} → {end}",
  "liveAdmin.openYoutube": "Abrir no YouTube",
  "liveAdmin.scoreTitle": "Placar",
  "liveAdmin.team1": "Equipa 1",
  "liveAdmin.team2": "Equipa 2",
  "liveAdmin.bannersTitle": "Banners",
  "liveAdmin.bannersSubtitle":
    "Selecione um banner para mostrar na transmissão",
  "liveAdmin.loopingMode": "Modo alternar automaticamente",
  "liveAdmin.on": "Ligado",
  "liveAdmin.off": "Desligado",
  "liveAdmin.narrationTitle": "Narração",
  "liveAdmin.micStatus": "Microfone: {status}",
  "liveAdmin.toggleMic": "Ativar/Desativar microfone",
  "liveAdmin.startNarration": "Iniciar narração",
  "liveAdmin.stopNarration": "Parar narração",
  "liveAdmin.narrationHint": "A narração é apenas um placeholder por enquanto.",
  "liveAdmin.logosTitle": "Logos",
  "liveAdmin.onboardingHint": "1. Envie o seu logo na biblioteca à direita → 2. Arraste para a posição desejada no quadro acima → 3. Clique em \"Guardar\".",
  "liveAdmin.musicSectionTitle": "Música de fundo",
  "liveAdmin.unsavedChanges": "Alterações não guardadas",
  "liveAdmin.selectLogo": "Selecionar logo para editar",
  "liveAdmin.addLogo": "Adicionar logo",
  "liveAdmin.newLogo": "Novo logo…",
  "liveAdmin.deleteLogo": "Excluir logo",
  "liveAdmin.addLogoTitle": "Adicionar logo",
  "liveAdmin.add": "Adicionar",
  "liveAdmin.cancel": "Cancelar",
  "liveAdmin.image": "Imagem",
  "liveAdmin.searchImage": "Pesquisar imagem…",
  "liveAdmin.searchPlaylist": "Pesquisar playlist…",
  "liveAdmin.position": "Posição",
  "liveAdmin.position.TOP_LEFT": "Superior esquerdo",
  "liveAdmin.position.TOP_RIGHT": "Superior direito",
  "liveAdmin.position.BOT_LEFT": "Inferior esquerdo",
  "liveAdmin.position.BOT_RIGHT": "Inferior direito",
  "liveAdmin.offsetX": "Offset X",
  "liveAdmin.offsetY": "Offset Y",
  "liveAdmin.saveLogo": "Guardar logo",
  "liveAdmin.saveAllLogos": "Guardar",
  "liveAdmin.saveLogosConfirmTitle": "Guardar logos?",
  "liveAdmin.saveLogosConfirmBody":
    "Alterou configurações de logos. Quer guardar antes de guardar a playlist?",
  "liveAdmin.continueWithoutSavingLogos": "Guardar playlist sem guardar logos",
  "liveAdmin.saveLogosAndContinue": "Guardar logos e guardar playlist",
  "liveAdmin.emptyLogoError":
    "Insira uma imagem ou remova o logótipo vazio antes de guardar.",
  "liveAdmin.reservedArea": "Área reservada (publicidade)",
  "liveAdmin.cameraView": "Visão da Câmera",
  "liveAdmin.dragHint":
    "Dica: arraste o logo para ajustar a posição no vídeo. Também pode aumentar ou diminuir o tamanho do logótipo.",
  "liveAdmin.musicTitle": "Música",
  "liveAdmin.playlist": "Playlist",
  "liveAdmin.savePlaylist": "Guardar playlist",
  "liveAdmin.uploadLogoMedia": "Enviar mídia para logo",

  // Live Playlists
  "livePlaylists.title": "Playlists",
  "livePlaylists.add": "Nova playlist",
  "livePlaylists.establishment": "Estabelecimento",
  "livePlaylists.id": "ID",
  "livePlaylists.name": "Descrição",
  "livePlaylists.youtubeId": "YouTube ID",
  "livePlaylists.youtubeHint":
    "Deixe em branco para criar no YouTube automaticamente.",
  "livePlaylists.youtubeAccountId": "Conta YouTube",
  "livePlaylists.youtubeAccountIdHint": "Escolhe a conta que será dona desta playlist no YouTube.",
  "livePlaylists.filterYoutubeAccount": "Filtrar por conta YouTube",
  "livePlaylists.youtubeAccountColumn": "Conta YouTube",
  "livePlaylists.actions": "Ações",
  "livePlaylists.empty": "Nenhuma playlist cadastrada.",
  "livePlaylists.createTitle": "Criar playlist",
  "livePlaylists.editTitle": "Editar playlist",
  "livePlaylists.save": "Guardar",
  "livePlaylists.cancel": "Cancelar",

  // Live Media Library
  "liveMedia.title": "Mídias",
  "liveMedia.upload": "Carregar mídia",
  "liveMedia.empty": "Nenhuma mídia cadastrada.",

  // Live Details
  // Live Workspace
  "liveWorkspace.tabs.detalhes": "Detalhes",
  "liveWorkspace.tabs.pagamento": "Pagamento",
  "liveWorkspace.tabs.branding": "Logos/Músicas",
  "liveWorkspace.tabs.placar": "Marcador",
  "liveWorkspace.comingSoon": "Brevemente nesta aba.",

  "liveDetails.title": "Detalhes da Transmissão",
  "liveDetails.scoreboardButton": "Placar",
  "liveDetails.back": "Voltar",
  "liveDetails.openBranding": "Logos/Músicas",
  "liveDetails.payRequiredToConfigure":
    "Pague a transmissão para aceder a logos e configurar.",
  "liveDetails.scheduleChangeDuringStreamHint": "Alterações de agendamento durante a transmissão podem exigir reinício para aplicar imediatamente.",
  "liveDetails.restartDialogTitle": "Alteração durante a transmissão",
  "liveDetails.restartDialogBody": "Para que as alterações ocorram durante a transmissão, será necessário reiniciar. Deseja reiniciar agora ou mais tarde?",
  "liveDetails.restartLater": "Reiniciar mais tarde",
  "liveDetails.restartNow": "Reiniciar agora",
  "liveDetails.tabs.overview": "Geral",
  "liveDetails.tabs.schedules": "Agendamentos",
  "liveDetails.tabs.emails": "E-mails",
  "liveDetails.tabs.service": "Serviço",
  "liveDetails.name": "Título da Transmissão",
  "liveDetails.privacy": "Privacidade",
  "liveDetails.privacyPublic": "Público",
  "liveDetails.privacyUnlisted": "Não listado",
  "liveDetails.privacyPrivate": "Privado",
  "liveDetails.privacyPublicHint": "Qualquer pessoa pode encontrar e assistir a esta transmissão.",
  "liveDetails.privacyUnlistedHint": "Só quem tiver o link consegue assistir; não aparece em pesquisas.",
  "liveDetails.privacyPrivateHint": "Apenas pessoas autorizadas por si podem assistir.",
  "liveDetails.enableAudio": "Ativar áudio",
  "liveDetails.backgroundMusic": "Música de fundo",
  "liveDetails.yes": "Sim",
  "liveDetails.no": "Não",
  "liveDetails.save": "Guardar",
  "liveDetails.saveConfig": "Guardar",
  "liveDetails.discardChanges": "Descartar alterações",
  "liveDetails.status": "Estado",
  "liveDetails.playlist": "Playlist",
  "liveDetails.youtubeKeyId": "ID da chave do YouTube",
  "liveDetails.youtubeKey": "Chave do YouTube",
  "liveDetails.dropletId": "Droplet ID",
  "liveDetails.paid": "Pago",
  "liveDetails.device": "Local/Dispositivo",
  "liveDetails.paymentPreference": "Preferência de pagamento",
  "liveDetails.billedValue": "Valor cobrado",
  "liveDetails.paidLastStatus": "Último status do pagamento",
  "liveDetails.initiatedByEmail": "Iniciado por (email)",
  "liveDetails.initiatedByRole": "Iniciado por (perfil)",
  "liveDetails.schedulesTitle": "Agendamentos",
  "liveDetails.addSchedule": "Adicionar agendamento",
  "liveDetails.editSchedule": "Editar agendamento",
  "liveDetails.scheduleStartedDateLocked":
    "Esta transmissão já está em direto — só é possível alterar a descrição.",
  "liveDetails.appendDescription": "Descrição",
  "liveDetails.startAt": "Início",
  "liveDetails.endAt": "Fim",
  "liveDetails.cancel": "Cancelar",
  "liveDetails.create": "Criar",
  "liveDetails.edit": "Editar",
  "liveDetails.delete": "Excluir",
  "liveDetails.deleteScheduleTitle": "Excluir agendamento",
  "liveDetails.deleteScheduleMessage": "Tem a certeza que deseja excluir este agendamento de transmissão? Esta ação não pode ser desfeita.",
  "liveDetails.deleteScheduleMessageStarted":
    "Esta transmissão já está em direto. Excluir este agendamento cancela a transmissão no YouTube agora mesmo. Esta ação não pode ser desfeita.",
  "liveDetails.deleteLive": "Excluir live",
  "liveDetails.deleteLiveTitle": "Excluir live",
  "liveDetails.deleteLiveMessage": "Tem a certeza que deseja excluir esta live e todos os seus agendamentos? Esta ação não pode ser desfeita.",
  "liveDetails.noSchedules": "Nenhum agendamento encontrado.",
  "liveDetails.scheduleStatus": "Estado",
  "liveDetails.emailsTitle": "E-mails",
  "liveDetails.email": "E-mail",
  "liveDetails.add": "Adicionar",
  "liveDetails.remove": "Excluir",
  "liveDetails.noEmails": "Nenhum e-mail registado.",
  "liveDetails.serviceTitle": "Serviço",
  "liveDetails.toggleDroplet": "Iniciar/Parar serviço",
  "liveDetails.restartService": "Reiniciar serviço",
  "liveDetails.viewLogs": "Ver logs",
  "liveDetails.logsTitle": "Logs",
  "liveDetails.close": "Fechar",
  "liveDetails.adminOnlyService":
    "Apenas administradores podem iniciar/reiniciar o serviço e ver logs.",

  "liveService.title": "Iniciar transmissão",
  "liveService.startStream": "Iniciar transmissão",
  "liveService.stopStream": "Finalizar transmissão",
  "liveService.autoLogs": "Atualizar logs",
  "liveService.autoLogsHint": "a atualizar…",
  "liveService.logsPlaceholder": "Sem logs ainda.",
  "liveService.logsNotAvailable":
    "Logs indisponíveis para este serviço (droplet não encontrado).",
  "liveService.starting": "A iniciar transmissão…",
  "liveService.stopping": "A finalizar transmissão…",
  "liveService.restarting": "A reiniciar serviço…",
  "liveService.refreshFailed": "Ação aplicada, mas não foi possível atualizar o estado no ecrã. Atualize a página.",
  "liveService.brandingSavedRestartFailed": "Configurações guardadas, mas não foi possível reiniciar a transmissão para aplicar agora. Reinicie manualmente se necessário.",
  "liveService.notStarted":
    "Serviço não iniciou. Verifique o backend (droplet/logs).",
  "liveService.finishedHint":
    "Transmissão finalizada. Para iniciar novamente, crie uma nova transmissão.",

  // Live Scoreboard
  "liveScoreboard.pageTitle": "Placar da transmissão",
  "liveScoreboard.pageSubtitle": "Frontend do placar para operação da live.",
  "liveScoreboard.liveFallback": "Placar da transmissão",
  "liveScoreboard.liveFallbackWithId": "Transmissão #{id}",
  "liveScoreboard.simpleFlowHint":
    "Configuração do placar sincronizada com a transmissão.",
  "liveScoreboard.saveSuccess": "Configuração do placar guardada.",
  "liveScoreboard.saveWarning":
    "Não foi possível guardar no backend agora. Preferência aplicada localmente.",
  "liveScoreboard.emptyNamesError": "Preencha os nomes do marcador antes de guardar.",
  "liveScoreboard.saveBeforeGenerateLinkWarning":
    "Não foi possível guardar a configuração do placar antes de gerar o link do administrador.",
  "liveScoreboard.logoFallback": "Logo",
  "liveScoreboard.overlayName": "Placar",
  "liveScoreboard.defaultLogoName": "Meu Lance",
  "liveScoreboard.overlay.teamA": "• EQUIPA A",
  "liveScoreboard.overlay.teamB": "EQUIPA B",
  "liveScoreboard.overlay.pointHeader": "PONTOS",
  "liveScoreboard.overlay.primaryHeader": "GAMES",
  "liveScoreboard.overlay.scoreHeader": "SCORE",
  "liveScoreboard.overlay.pointShort": "PT",
  "liveScoreboard.overlay.setShort": "SETS",
  "liveScoreboard.configTag": "AGENDAMENTO / CONFIGURAÇÃO",
  "liveScoreboard.configTitle": "Ativar placar na transmissão",
  "liveScoreboard.configDescription":
    "Na criação da live, o dono do clube escolhe o desporto. Depois disso, o sistema gera automaticamente o link de administrador para operar o placar ao vivo.",
  "liveScoreboard.broadcastLabel": "Placar na transmissão",
  "liveScoreboard.enabled": "Ativado",
  "liveScoreboard.disabled": "Desativado",
  "liveScoreboard.toggleLabel": "Incluir placar na visão da câmara",
  "liveScoreboard.musicToggleLabel": "Incluir música de fundo na transmissão",
  "liveScoreboard.savingHint": "A guardar preferência do placar...",
  "liveScoreboard.sportTypeLabel": "Desporto do placar",
  "liveScoreboard.sport.football": "Futebol",
  "liveScoreboard.sport.padel": "Padel",
  "liveScoreboard.sport.beachTennis": "Beach Tennis",
  "liveScoreboard.generateAdminLink": "Gerar link do administrador",
  "liveScoreboard.adminLinkLabel": "Link do administrador",
  "liveScoreboard.adminTag": "ADMINISTRADOR / {sport}",
  "liveScoreboard.adminPanelTitle": "Painel do placar",
  "liveScoreboard.adminFootballDescription":
    "O funcionário do clube abre o link e controla tudo apenas nos botões de mais e menos.",
  "liveScoreboard.adminPadelDescription":
    "Também funciona só com mais e menos. O sistema entende a progressão do ponto automaticamente.",
  "liveScoreboard.adminBeachDescription":
    "Mesmo comportamento do padel, mantendo a operação simples e rápida durante a transmissão.",
  "liveScoreboard.enableToEdit":
    "Ative o placar na transmissão para libertar edição.",
  "liveScoreboard.team1Upper": "EQUIPA 1",
  "liveScoreboard.team2Upper": "EQUIPA 2",
  "liveScoreboard.teamA": "Equipa A",
  "liveScoreboard.teamB": "Equipa B",
  "liveScoreboard.matchTime": "Tempo da partida",
  "liveScoreboard.liveNow": "Ao vivo",
  "liveScoreboard.matchTimeLive": "{time} ({status})",
  "liveScoreboard.pair1Upper": "DUPLA 1",
  "liveScoreboard.pair2Upper": "DUPLA 2",
  "liveScoreboard.games": "Jogos",
  "liveScoreboard.sets": "Sets",
  "liveScoreboard.currentPoint": "Ponto atual",
  "liveScoreboard.ruleHintPadel":
    "Exemplo da regra automática: se estiver em 15 e tocar em mais, avança para 30. Tocando de novo, vai para 40.",
  "liveScoreboard.youtubeTitle": "Ecrã no YouTube - {sport}",
  "liveScoreboard.setLabel": "SET {set}",
  "liveScoreboard.summaryLine":
    "Sets: {setsA} x {setsB} | Ponto: {pointA} x {pointB}",
  "liveScoreboard.adminLinkSaved": "Configurações do link do administrador guardadas com sucesso.",
  "liveScoreboard.adminLinkWarning":
    "Este link será usado por terceiros sem acesso à plataforma. Partilhe o link e o código de acesso apenas com quem vai operar o placar desta partida.",
  "liveScoreboard.adminAccessCodeLabel": "Código de acesso",
  "liveScoreboard.adminAccessCodeNotRecoverable":
    "O código não pode ser mostrado novamente. Gere um novo link para definir outro código.",
  "liveScoreboard.adminAccessCodeHelp":
    "Até 8 caracteres (letras e números). Se deixar em branco, será gerado automaticamente.",
  "liveScoreboard.generateRandomCode": "Gerar código aleatório",
  "liveScoreboard.adminLinkModalTitle": "Configurar link do administrador",
  "liveScoreboard.saveAdminLinkConfig": "Guardar configurações do link do administrador",
  "liveScoreboard.adminLinkExpirationLabel": "Expiração do link",
  "liveScoreboard.adminLinkExpirationFallback": "Expira 5 minutos após o fim da transmissão.",
  "liveScoreboard.adminLinkExpirationValue": "Expiração do link: {dateTime}",
  "liveScoreboard.public.accessCodeLabel": "Código de acesso",
  "liveScoreboard.public.accessCodeHelp": "Digite o código de acesso recebido com o link.",
  "liveScoreboard.public.unlock": "Aceder ao placar",
  "liveScoreboard.public.operatorTag": "OPERADOR DO PLACAR",
  "liveScoreboard.public.liveFallback": "Placar da transmissão",
  "liveScoreboard.public.invalidLink": "Link inválido. Verifique o código de acesso.",
  "liveScoreboard.public.disabledForLive": "Placar desativado para esta transmissão.",
  "liveScoreboard.public.expired":
    "Esta transmissão já terminou. Este link expirou e o acesso público ao placar termina 5 minutos após o fim da transmissão.",
  "liveScoreboard.public.accessDenied":
    "Acesso negado. O placar está desativado ou o código é inválido.",
  "liveScoreboard.public.accessUnavailable":
    "Não foi possível aceder a este placar com os dados informados.",
  "liveScoreboard.public.saveRetryable":
    "Não foi possível guardar agora. Tente novamente.",
  "liveScoreboard.public.notFound": "Link de operador não encontrado.",
  "liveScoreboard.public.loadError": "Não foi possível carregar este placar agora.",
  "liveScoreboard.public.expiredSave": "Link expirado. Já não é possível atualizar este placar.",

  // Notifications
  "notifications.title": "Notificações",
  "notifications.noIssues": "Nenhum problema encontrado",
  "notifications.issueItem": "{establishment}: {device} — {reasons}",
  "notifications.reason.OFFLINE": "Câmara offline",
  "notifications.reason.SD_CARD_ERROR": "Cartão SD com erro",
  "notifications.reason.BUTTON_SHORT_CIRCUIT": "Botoneira em curto",

  // Metric Chart
  "metricChart.channel": "Câmara",
  "metricChart.total": "Total",
  "metricChart.grandTotal": "Total Geral",
  "metricChart.loadError": "Erro ao carregar métricas",
  "metricChart.errorState": "Não foi possível carregar as métricas agora. Tente novamente dentro de instantes.",
  "metricChart.showAll": "Exibir todas (+{count})",
  "metricChart.showLess": "Exibir menos",
  "metricChart.noData": "Nenhum dado encontrado.",
  "metricChart.metricsOmitted":
    "{count} métricas omitidas. Melhore os filtros para visualizar dados específicos.",

  // Analytics Reporter (legado)
  "analyticsReporter.title": "Relatório de Analytics",
  "analyticsReporter.startDate": "Data Inicial",
  "analyticsReporter.endDate": "Data Final",
  "analyticsReporter.search": "Buscar estabelecimento",
  "analyticsReporter.eventType": "Tipo de Evento",
  "analyticsReporter.generate": "Gerar Relatório",
  "analyticsReporter.total": "Total",
  "analyticsReporter.establishment": "Estabelecimento",
  "analyticsReporter.action": "Ação",
  "analyticsReporter.count": "Qtd",
  "analyticsReporter.errorMaxDays": "O intervalo de datas não pode exceder {maxDays} dias.",
  "analyticsReporter.loading": "A carregar...",
  "analyticsReporter.noData": "Nenhum dado encontrado.",
  "analyticsReporter.generating": "A gerar relatório...",
  "analyticsReporter.errorFetch": "Erro ao gerar relatório.",

  // Analytics V2
  "analyticsV2.title": "Relatórios",
  "analyticsV2.startDate": "Data Inicial",
  "analyticsV2.endDate": "Data Final",
  "analyticsV2.metric": "Métrica",
  "analyticsV2.format": "Formato",
  "analyticsV2.table": "Tabela",
  "analyticsV2.chart": "Gráfico",
  "analyticsV2.granularity": "Granularidade",
  "analyticsV2.daily": "Diário",
  "analyticsV2.monthly": "Mensal",
  "analyticsV2.total": "Total",
  "analyticsV2.groupBy": "Agrupar por:",
  "analyticsV2.court": "Quadra",
  "analyticsV2.all": "Todos",
  "analyticsV2.generateReport": "Gerar Relatório",
  "analyticsV2.totalEvents": "Total de eventos: {total}",
  "analyticsV2.chartNotAvailable":
    "Gráfico não disponível para granularidade Total. Use formato Tabela.",
  "analyticsV2.establishment": "Estabelecimento",
  "analyticsV2.event": "Evento",
  "analyticsV2.quantity": "Quantidade",
  "analyticsV2.date": "Data",
  "analyticsV2.noDataFound": "Nenhum dado encontrado.",
  "analyticsV2.selectMetric": "Selecione uma métrica",
  "analyticsV2.selectEstablishment": "Selecione pelo menos um estabelecimento",
  "analyticsV2.reportError": "Erro ao gerar relatório",
  "analyticsV2.download": "Transferir CSV",
  "analyticsV2.downloadError": "Erro ao transferir relatório",
  "analyticsV2.reportTitle": "Relatório - {metric}",
  "analyticsV2.period": "Período: {start} ~ {end}",
  "analyticsV2.channel": "Canal",
  "analyticsV2.description": "Descrição",

  // Metrics
  "metrics.custom_downloaded_video_2": "Transferir Vídeo",
  "metrics.custom_played_video_2": "Visualização de Vídeo",
  "metrics.video_statistics": "Estatísticas de Vídeo",
  "metrics.custom_whatsapp_opening": "Abertura do WhatsApp",
  "metrics.scroll": "Rolagem",
  "metrics.custom_played_live": "Visualização de Live",
  "metrics.custom_sponsor_banner": "Banner do Patrocinador",
  "metrics.custom_prospectpro_banner": "Banner do patrocinador",
  "metrics.custom_prospectpro_popup": "Popup do patrocinador",
  "metrics.custom_deixacomochef_banner": "Banner do Deixa Com o Chef",
  "metrics.custom_deixacomochef_popup": "Popup do Deixa Com o Chef",
  "metrics.page_view": "Visualização de Página",
  "metrics.custom_instagram_opening": "Abertura do Instagram",
  "metrics.click": "Clique",
  "metrics.session_start": "Início de Sessão",
  "metrics.first_visit": "Primeira Visita",
  "metrics.user_engagement": "Envolvimento do Utilizador",
  "metrics.file_download": "Transferir Ficheiro",

  // Subscriptions Dashboard
  "subscriptions.title": "Assinaturas",
  "subscriptions.activeSubscriptions": "Assinaturas Activas",
  "subscriptions.cancelledSubscriptions": "Assinaturas Canceladas",
  "subscriptions.expiredSubscriptions": "Assinaturas Expiradas",
  "subscriptions.singlePurchases": "Compras Avulsas",
  "subscriptions.subscriptionRevenueCollected": "Receita Recebida (Subscrições)",
  "subscriptions.subscriptionRevenueTrial": "Em Trial (projetada, não recebida)",
  "subscriptions.singleRevenue": "Receita Compras Avulsas",
  "subscriptions.totalRevenue": "Receita Total Recebida",
  "subscriptions.noRecords": "Nenhum registo encontrado.",
  "subscriptions.searchPlaceholder": "Buscar por nome ou e-mail...",
  "subscriptions.filterType": "Tipo",
  "subscriptions.filterStatus": "Estado",
  "subscriptions.filterOffering": "Produto",
  "subscriptions.filterStartDate": "Data Início",
  "subscriptions.filterEndDate": "Data Fim",
  "subscriptions.columnName": "Nome",
  "subscriptions.columnEmail": "E-mail",
  "subscriptions.columnType": "Tipo",
  "subscriptions.columnOffering": "Produto",
  "subscriptions.columnAmount": "Valor",
  "subscriptions.columnStatus": "Estado",
  "subscriptions.columnDate": "Data",
  "subscriptions.columnNextBilling": "Próx. Cobrança",
  "subscriptions.columnCancellation": "Data Cancel.",
  "subscriptions.columnGatewayId": "ID Gateway",
  "subscriptions.rowsPerPage": "Linhas por página",
  "subscriptions.metricsExcludeTestNote": "Os números abaixo não incluem subscrições marcadas como teste. Valores \"em trial\" ainda não foram cobrados.",
  "subscriptions.metricsCounts": "Contagens",
  "subscriptions.metricsRevenue": "Receita",
  "subscriptions.filterIncludeTest": "Mostrar testes",
  "subscriptions.hiddenTestCount": "{count} subscrição(ões) de teste oculta(s) dos números e da lista.",
  "subscriptions.filterBillingPhase": "Fase",
  "subscriptions.billingPhase.trial": "Em trial",
  "subscriptions.billingPhase.active": "A cobrar",
  "subscriptions.testChip": "Teste",
  "subscriptions.trialChip": "Em trial",

  "subscriptionDetail.title": "Detalhes da Transação",
  "subscriptionDetail.visitorInfo": "Informações do Visitante",
  "subscriptionDetail.phone": "Telefone",
  "subscriptionDetail.transactionData": "Dados da Transação",
  "subscriptionDetail.type": "Tipo",
  "subscriptionDetail.product": "Produto",
  "subscriptionDetail.cycle": "Ciclo",
  "subscriptionDetail.value": "Valor",
  "subscriptionDetail.purchaseDate": "Data da Compra",
  "subscriptionDetail.nextBilling": "Próxima Cobrança",
  "subscriptionDetail.cancellation": "Cancelamento",
  "subscriptionDetail.technicalDetails": "Detalhes técnicos",
  "subscriptionDetail.internalTransactionId": "ID da Transação (interno)",
  "subscriptionDetail.externalId": "ID Externo (MP)",
  "subscriptionDetail.gatewayPaymentId": "Gateway Payment ID",
  "subscriptionDetail.subscriptionExternalId": "Subscription External ID",
  "subscriptionDetail.historyTitle": "Histórico de Transações do Visitante",
  "subscriptionDetail.noDataFound": "Nenhum dado encontrado para esta transação.",
  "subscriptionDetail.type.subscription": "Assinatura",
  "subscriptionDetail.type.singlePurchase": "Avulsa",
  "subscriptionDetail.cycle.monthly": "Mensal",
  "subscriptionDetail.cycle.annual": "Anual",
  "subscriptionDetail.status.approved": "Aprovado",
  "subscriptionDetail.status.pending": "Pendente",
  "subscriptionDetail.status.rejected": "Rejeitado",
  "subscriptionDetail.status.cancelled": "Cancelado",
  "subscriptionDetail.status.superseded": "Substituído",
  "subscriptionDetail.testChip": "Subscrição de teste",
  "subscriptionDetail.trialChip": "Em período de trial",
  "subscriptionDetail.markAsTest": "Marcar como teste",
  "subscriptionDetail.unmarkAsTest": "Remover marcação de teste",
  "subscriptionDetail.testMarkedBy": "Marcado como teste por {name} em {date}",
  "subscriptionDetail.testFlagUpdateSuccess": "Marcação de teste atualizada.",
  "subscriptionDetail.testFlagUpdateError": "Não foi possível atualizar a marcação de teste.",
  // Auditoria
  "auditLogs.title": "Auditoria",
  "auditLogs.tabActivities": "Atividades",
  "auditLogs.tabRequests": "Requisições",
  "auditLogs.when": "Quando",
  "auditLogs.who": "Quem",
  "auditLogs.what": "O que fez",
  "auditLogs.entity": "Entidade",
  "auditLogs.entityId": "ID",
  "auditLogs.method": "Método",
  "auditLogs.route": "Rota",
  "auditLogs.statusCode": "Estado",
  "auditLogs.duration": "Duração",
  "auditLogs.filterUser": "Quem",
  "auditLogs.filterCategory": "Categoria",
  "auditLogs.filterAction": "Ação",
  "auditLogs.filterDateFrom": "De",
  "auditLogs.filterDateTo": "Até",
  "auditLogs.filterButton": "Filtrar",
  "auditLogs.placeholderEmail": "E-mail do utilizador",
  "auditLogs.empty": "Nenhum registo encontrado",
  "auditLogs.selectCategoryFirst": "Selecione uma categoria primeiro",
  "auditLogs.allActions": "Todas as ações",
  "auditLogs.sessionExpired": "Sessão expirada. Faça login novamente.",
  "logoModels.title": "Os meus modelos",
  "logoModels.subtitle": "Conjuntos de logos guardados para este estabelecimento",
  "logoModels.empty": "Ainda não existem modelos guardados",
  "logoModels.noEstablishment": "Estabelecimento não identificado nesta transmissão",
  "logoModels.saveAsModel": "Guardar como modelo",
  "logoModels.saveAsModelTitle": "Guardar como modelo",
  "logoModels.nameLabel": "Nome do modelo",
  "logoModels.nameRequired": "Indique um nome",
  "logoModels.logosRequired": "Adicione pelo menos um logo antes de guardar como modelo",
  "logoModels.created": "Modelo criado",
  "logoModels.updated": "Modelo atualizado",
  "logoModels.deleted": "Modelo eliminado",
  "logoModels.createTitle": "Novo modelo",
  "logoModels.renameTitle": "Renomear modelo",
  "logoModels.createHint": "O modelo será criado com os logos configurados nesta transmissão.",
  "logoModels.apply": "Aplicar",
  "logoModels.rename": "Renomear",
  "logoModels.delete": "Eliminar",
  "logoModels.deleteTitle": "Eliminar modelo?",
  "logoModels.deleteConfirm": "Tem a certeza de que pretende eliminar o modelo \"{name}\"? Os logos na transmissão não serão alterados.",
  "logoModels.applied": "Modelo aplicado",
  "logoModels.logoCount": "{count, plural, one {# logo} other {# logos}}",
  "logoModels.newModel": "Novo modelo",
  "logoModels.suggestTitle": "Reutilizar logos",
  "logoModels.suggestBody": "O último modelo usado nesta quadra foi \"{name}\". Pretende reutilizá-lo?",
  "logoModels.suggestReuse": "Reutilizar",
  "logoModels.suggestChooseOther": "Escolher outro",
  "logoModels.suggestSetupManually": "Configurar manualmente",
};
